import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DatePipe, NgForOf, NgIf} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {FormsModule} from "@angular/forms";
import {PlanningApiService} from "../../../../services/api/planning-api.service";
import {ToastService} from "../../../../services/toaster.service";
import {BaseComponent} from "../../../base/base.component";

@Component({
  selector: 'app-planning-region-taux-modal',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    TranslateModule,
    FormsModule,
    DatePipe
  ],
  templateUrl: './planning-region-taux-modal.component.html',
  styleUrls: ['./planning-region-taux-modal.component.scss']
})
export class PlanningRegionTauxModalComponent extends BaseComponent {
  @Input() taux: any[] = [];
  @Input() title: string = '';
  @Input() updateTaux: (event: any, idWeek: boolean) => void = () => {};
  commonTaux: string = '';

  constructor(public activeModal: NgbActiveModal,
              private planningApiService: PlanningApiService,
              private toastService: ToastService) {
    super();
  }

  closeModal() {
    this.activeModal.close();
  }

  setCommonTaux() {
    const newTaux = this.commonTaux;
    if (newTaux !== '') {
      this.taux = this.taux.map(tauxItem => ({
        ...tauxItem,
        taux: newTaux
      }));
    }
  }

  saveAllTaux() {
    this.planningApiService.updateTaux(this.cookies, this.taux).subscribe({
      next: (response) => {
        this.toastService.showSuccess('toast.success');
        this.closeModal()
      },
      error: (error) => {
        this.toastService.showDanger('toast.error');
      },
    });
  }

}
